export default "__VITE_ASSET__1d5bb7fd__"